<header class="relative px-4 pb-4 pt-2">
  <h1 class="text-2xl font-semibold text-greyscale-900">Document analysis jobs</h1>
  <p class="text-sm text-greyscale-600">
    Monitor AI brochure extraction jobs across all companies
  </p>
</header>

<main class="p-4">
  <p-table [value]="jobs" [paginator]="false" styleClass="p-datatable-sm" [loading]="loading">
    <ng-template #caption>
      <div class="flex flex-wrap items-end gap-4">
        <div class="min-w-[150px]">
          <span class="mb-1 block text-sm font-medium">Status</span>
          <p-select
            [options]="statusOptions"
            [(ngModel)]="statusFilter"
            (onChange)="onFilterChange()"
            optionLabel="label"
            optionValue="value"
            placeholder="All statuses"
            [style]="{ width: '100%' }"
          />
        </div>
        <div class="min-w-[150px]">
          <span class="mb-1 block text-sm font-medium">Type</span>
          <p-select
            [options]="typeOptions"
            [(ngModel)]="typeFilter"
            (onChange)="onFilterChange()"
            optionLabel="label"
            optionValue="value"
            placeholder="All types"
            [style]="{ width: '100%' }"
          />
        </div>
        <div class="min-w-[200px]">
          <span class="mb-1 block text-sm font-medium">Company</span>
          <p-select
            [options]="companyOptions"
            [(ngModel)]="companyFilter"
            (onChange)="onFilterChange()"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterBy="label"
            placeholder="All companies"
            [style]="{ width: '100%' }"
          />
        </div>
        <div>
          <p-button
            icon="pi pi-filter-slash"
            (onClick)="resetFilters()"
            [text]="true"
            [rounded]="true"
            pTooltip="Reset filters"
          />
        </div>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th>Date</th>
        <th>File</th>
        <th>Company / User</th>
        <th>Type</th>
        <th>Trip</th>
        <th>Status</th>
      </tr>
    </ng-template>

    <ng-template #body let-job>
      <tr class="cursor-pointer hover:bg-gray-50 h-14" (click)="viewDetails(job.id)">
        <td>{{ formatDate(job.createdAt) }}</td>

        <td>
          <div [pTooltip]="job.originalFileName" class="max-w-[240px] truncate font-medium">
            {{ job.originalFileName }}
          </div>
        </td>

        <td>
          <div class="font-medium">{{ job.company.name }}</div>
          <div class="text-xs text-gray-500">
            {{ job.user.firstName }} {{ job.user.lastName }}
          </div>
        </td>

        <td>
          <span
            class="px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap"
            [ngClass]="
              getJobType(job) === DocumentJobType.SINGLE
                ? 'bg-primary-100 text-primary-700'
                : 'bg-greyscale-100 text-greyscale-700'
            "
          >
            {{ getJobType(job) === DocumentJobType.SINGLE ? 'Single' : 'Batch' }}
          </span>
        </td>

        <td>
          @if (job.trip) {
            <div [pTooltip]="job.trip.title" class="max-w-[200px] truncate text-primary-700">
              {{ job.trip.title }}
            </div>
          } @else {
            <span class="text-xs text-gray-400">--</span>
          }
        </td>

        <td>
          <span
            class="px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap"
            [ngClass]="getStatusClasses(job.status)"
          >
            {{ job.status }}
          </span>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="6" class="text-center py-12">
          <i class="pi pi-inbox text-4xl text-gray-400 mb-4"></i>
          <p class="text-gray-500">No document jobs found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="flex items-center justify-between mt-4">
    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-600">Items per page:</span>
      <p-select
        [options]="pageSizeOptions"
        [(ngModel)]="pageSize"
        (onChange)="onPageSizeChange()"
        optionLabel="label"
        optionValue="value"
        [style]="{ width: '80px' }"
      />
      <span class="text-sm text-gray-600 ml-4">Total: {{ totalRecords }} job(s)</span>
    </div>

    <div class="flex items-center gap-2">
      <p-button
        icon="pi pi-angle-left"
        (onClick)="onPageChange(currentPage - 1)"
        [disabled]="currentPage === 1"
        [text]="true"
      />
      <span class="text-sm text-gray-600">Page {{ currentPage }} of {{ totalPages }}</span>
      <p-button
        icon="pi pi-angle-right"
        (onClick)="onPageChange(currentPage + 1)"
        [disabled]="currentPage === totalPages || totalPages === 0"
        [text]="true"
      />
    </div>
  </div>
</main>

<p-toast />
